import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const VolumeUpIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "VolumeUp",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.58 3.66c-.18-.07-.38-.12-.59-.12-.43 0-.82.18-1.1.46L9.12 9.77H3.56c-.86 0-1.55.69-1.56 1.55v9.35c0 .86.7 1.56 1.56 1.56h5.55L14.88 28c.28.28.67.45 1.1.45h.01c.21 0 .41-.04.59-.12.57-.23.96-.79.96-1.43V5.1c0-.65-.39-1.2-.95-1.44zm3.67 14.97c-.38.29-.63.74-.63 1.25 0 .86.69 1.55 1.55 1.55h.03c.34 0 .66-.12.91-.31a6.403 6.403 0 0 0 .02-10.23h-.02c-.26-.21-.58-.32-.93-.32-.86 0-1.56.7-1.56 1.56 0 .51.24.96.62 1.24.8.61 1.31 1.56 1.31 2.63s-.51 2.02-1.3 2.62Zm1.37-13.88a1.5 1.5 0 0 0-.44-.06c-.7 0-1.3.47-1.49 1.11-.04.14-.06.3-.06.45 0 .7.46 1.29 1.1 1.49h.01c3.59 1.09 6.16 4.38 6.16 8.26s-2.57 7.17-6.1 8.24l-.06.02c-.66.19-1.13.79-1.13 1.5 0 .86.7 1.56 1.56 1.56h.01c.16 0 .31-.02.45-.07h-.01c4.88-1.5 8.36-5.96 8.39-11.23-.02-5.28-3.51-9.75-8.3-11.24l-.08-.02Z"
    })
  }));
};